export const purple = {
  main: "#8051FF",
  16: "#1C004F",
  15: "#3B0093",
  14: "#5700D1",
  13: "#7126FF",
  12: "#8051FF",
  11: "#9474FF",
  10: "#AA95FF",
  9: "#C7BCFF",
  8: "#D4CCFF",
  7: "#DFD9FF",
  6: "#E4DEFF",
  5: "#E9E5FF",
  4: "#EFECFF",
  3: "#F3F1FF",
  2: "#F8F7FF",
  1: "#FDFDFF",
}
